// frontend/src/components/admin/AdminStatsSessionsChart.js
import React, { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import '../../css/Admin.css';

const AdminStatsSessionsChart = ({ userStats }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (!userStats || userStats.length === 0) return <p>Aucune donnée disponible.</p>;

  // Agrégation par semaine
  const weeksMap = {};
  userStats.forEach(stat => {
    const week = new Date(stat.weekStart).toLocaleDateString();
    if (!weeksMap[week]) {
      weeksMap[week] = { week, totalSessions: 0, totalDuration: 0, sessionCount: 0 };
    }
    if (stat.nbSessions > 0) {
      weeksMap[week].totalSessions += stat.nbSessions;
      weeksMap[week].totalDuration += stat.avgSessionDuration * stat.nbSessions;
      weeksMap[week].sessionCount += stat.nbSessions;
    }
  });

  const chartData = Object.values(weeksMap).map(w => ({
    week: w.week,
    nbSessions: w.totalSessions,
    avgDuration: w.sessionCount ? Math.round(w.totalDuration / w.sessionCount / 60) : 0 // conversion en minutes
  }));

  return (
    <div className="sessions-chart-panel">
      <h2
        className="sessions-chart-title cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        Sessions Utilisateurs {isOpen ? '▼' : '▲'}
      </h2>

      {isOpen && (
        <div className="sessions-chart-row">
          {/* Nombre de sessions */}
          <div className="sessions-chart-col">
            <h3 className="sessions-chart-subtitle">Nombre de sessions</h3>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="sessionsColor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#3b82f6" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Area type="monotone" dataKey="nbSessions" stroke="#2563eb" fill="url(#sessionsColor)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>

          {/* Durée moyenne des sessions en minutes */}
          <div className="sessions-chart-col">
            <h3 className="sessions-chart-subtitle">Durée moyenne (min)</h3>
            <ResponsiveContainer width="100%" height={200}>
              <AreaChart data={chartData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                <defs>
                  <linearGradient id="durationColor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#10b981" stopOpacity={0.8}/>
                    <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip formatter={(value) => `${value} min`} />
                <Area type="monotone" dataKey="avgDuration" stroke="#059669" fill="url(#durationColor)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStatsSessionsChart;
